import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import ListingCard from '../../Shared/ListingCard'

const ListingCardView = ({ listing, markListingAsSaved, isEagerLoad}) => {

  const handleOnSaveClick = useCallback(e => {
    e.stopPropagation()
    e.preventDefault()

    markListingAsSaved(listing)
  }, [listing])

  return (<ListingCard listing={listing} onSave={handleOnSaveClick} isEagerLoad={isEagerLoad}/>)
}

ListingCardView.propTypes = {
  listing: PropTypes.object,
  markListingAsSaved: PropTypes.func,
  isEagerLoad: PropTypes.bool
}

export default ListingCardView
